import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { useSiteContent } from "@/context/SiteContentContext";

const categoryOrder = [
  "Interfaz",
  "Backend",
  "Móvil",
  "Escritorio",
  "Base de datos",
  "Integraciones",
  "Marketing digital",
];

const categoryIcons: Record<string, string> = {
  Interfaz: "ri-layout-4-line",
  Backend: "ri-server-line",
  Móvil: "ri-smartphone-line",
  Escritorio: "ri-computer-line",
  "Base de datos": "ri-database-2-line",
  Integraciones: "ri-plug-2-line",
  "Marketing digital": "ri-megaphone-line",
};

export default function TechStack() {
  const { technologies, sections } = useSiteContent();
  const content = sections.tecnologias || {};

  const categories: { nombre: string; items: typeof technologies }[] = [];

  technologies.forEach((tech) => {
    const cat = tech.categoria || "Otros";
    let group = categories.find((c) => c.nombre === cat);
    if (!group) {
      group = { nombre: cat, items: [] };
      categories.push(group);
    }
    group.items.push(tech);
  });

  categories.sort((a, b) => {
    const ia = categoryOrder.indexOf(a.nombre);
    const ib = categoryOrder.indexOf(b.nombre);
    if (ia === -1 && ib === -1) return a.nombre.localeCompare(b.nombre);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });

  return (
    <section id="tecnologias" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Tecnologías"
          title={String(content.title || "Construimos con tecnología moderna.")}
          subtitle={String(
            content.subtitle || "Herramientas actuales y escalables para cada tipo de proyecto."
          )}
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat, i) => (
            <Reveal key={cat.nombre} delay={(i % 4) * 70}>
              <div className="h-full rounded-2xl border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:border-primary-200 hover:shadow-[0_12px_32px_rgba(30,60,120,0.07)]">
                <div className="flex items-center gap-3 mb-4">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                    <i className={`${categoryIcons[cat.nombre] || "ri-stack-line"} text-lg`} />
                  </span>
                  <h3 className="font-semibold text-foreground-950 text-sm md:text-base">
                    {cat.nombre}
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {cat.items.map((tech) => (
                    <span
                      key={tech.id}
                      className="inline-flex items-center gap-1.5 rounded-lg bg-background-100 border border-background-200 px-2.5 py-1.5 text-xs font-medium text-foreground-700 transition-all hover:border-primary-300 hover:text-primary-700 cursor-default"
                    >
                      <i
                        className={`${tech.icono || "ri-code-line"} text-primary-500 text-sm`}
                      />
                      {tech.nombre}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {technologies.length === 0 && (
          <p className="mt-12 text-center text-foreground-500">
            Pronto publicaremos nuestro stack tecnológico.
          </p>
        )}
      </div>
    </section>
  );
}